<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
        <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas"
            :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
            :opcionRetirar="opcionRetirar" :condicionales="condicionales" :carpeta="carpeta" :typeOrder="typeOrder"></TableGeneral>
    </div>
</template>
 
<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import TableGeneral from "../../components/Table.vue";
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import "vue-form-generator/dist/vfg-core.css";


Vue.use(VueFormGenerator)

const config = RepositoryFactory.get("config");
const clientes = RepositoryFactory.get("clientes");
export default {
    components: {
        "vue-form-generator": VueFormGenerator.component,
        TableGeneral,
        HeaderGeneral
    },
    data() {
        return {
            vista: "Mis solicitudes",
            proveniente: " - Mis solicitudes",
            typeOrder: "desc",
            carpeta: "Clientes",
            requiereListas: true,
            requiereDescarga: false,
            condicionFiltrao: "si",
            editable: 0,
            cliente: 1,
            opcionRetirar: true,
            options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' },
            { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'estado', text: 'Estado' }],
            optionss: [
                { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '2', text: 'Devuelto a institución' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },

            ],
            fields: [{ key: 'N° solicitud', sortable: true }, { key: 'Fecha solicitud', sortable: true },
            { key: 'Tipo documento', sortable: true }, { key: 'Documento', sortable: true },
            { key: 'Paciente', sortable: true },{ key: 'Médico tratante', sortable: true }, { key: 'Estado', sortable: true },
            { key: 'Observación', sortable: true }, 'Acciones'],
            condicionales_old: {
                "AND": [
                    {
                        "estado": {
                            "notEquals": "9"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "10"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "11"
                        }
                    },
                    

                ]
            },
            condicionales: null
        }

    },
    computed: {

    },
    async created() {
        const datosUser = localStorage.getItem('user');
        let datoUserJSON = JSON.parse(datosUser);
        let dato_cliente = datoUserJSON.id_cliente;
        if (dato_cliente == null) {
            this.condicionales = {
                "AND": [
                    {
                        "estado": {
                            "notEquals": "9"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "10"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "11"
                        }
                    }
                ]
            };

        } else {
            this.condicionales = {
                "AND": [
                    {
                        "estado": {
                            "notEquals": "9"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "10"
                        }
                    },
                    {
                        "estado": {
                            "notEquals": "11"
                        }
                    },
                    {
                        "id_cliente": {
                            "equals": dato_cliente.toString()
                        },
                    },


                ]
            };

        }

            
    },
    methods: {

    }
};
</script>
<style></style>